module.exports = __webpack_public_path__ + "static/media/cart-success-congratulations-icon.f67faa04.svg";